module.exports = __webpack_public_path__ + "html/text-block_9518cdb26dc3b6014aa631a5e43c1c21.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/text-block.html
// module id = aJIQ
// module chunks = 75